module.exports = __webpack_public_path__ + "media/application/images/ui/icon-youtube-eec14fe3e9f56f64f7b01d435854600a.png";